'use client';

import BenefitCardGrid from '@/app/(football)/[team]/_components/common/BenefitCardGrid';
import DecorativeHeader from '@/app/(football)/[team]/_components/common/DecorativeHeader';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useTopCollectorPageConfig } from '@/app/(football)/[team]/top-collector/_context/context';
import type { TopCollectorSeason } from '@/store/server/common/football/football.dto';

interface BenefitSectionProps {
  season: TopCollectorSeason;
}

export default function BenefitSection({ season }: BenefitSectionProps) {
  const { teamSlug, topCollector } = useTeamConfig();
  const { benefit } = useTopCollectorPageConfig();

  const isSecondSeason = season === 'second_top_collector';

  const captions =
    isSecondSeason && benefit.secondSeasonCaptions
      ? benefit.secondSeasonCaptions
      : benefit.captions;

  const useSecondSeasonImages = isSecondSeason && Boolean(topCollector.hasSecondSeasonBenefitImages);

  return (
    <section className="mt-10 flex w-full flex-col items-center gap-4">
      <DecorativeHeader>순위별 혜택</DecorativeHeader>

      <div className="flex w-full max-w-[320px] flex-col items-center gap-4">
        <BenefitCardGrid teamSlug={teamSlug} useSecondSeasonImages={useSecondSeasonImages} />

        {/* Benefit Captions */}
        <ul className="flex w-full flex-col items-start gap-2">
          {captions.map((caption) => (
            <BenefitCaption key={caption}>{caption}</BenefitCaption>
          ))}
        </ul>
      </div>

      <div className="mb-10" />
    </section>
  );
}

function BenefitCaption({ children }: { children: React.ReactNode }) {
  return (
    <li className="relative pl-[10px] whitespace-pre-line typo-caption-1 text-g-00">
      <span className="absolute top-[5.5px] left-0 h-[3px] w-[3px] rounded-full bg-g-00" />
      {children}
    </li>
  );
}
